import { render, staticRenderFns } from "./g-image.vue?vue&type=template&id=4c864fae&scoped=true"
import script from "./g-image.vue?vue&type=script&lang=ts"
export * from "./g-image.vue?vue&type=script&lang=ts"
import style0 from "./g-image.vue?vue&type=style&index=0&id=4c864fae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c864fae",
  null
  
)

export default component.exports